<script setup>
import { ref, toRefs } from 'vue'
import Rules from '../components/Rules.vue'
import LaunchersData from '../configs/launcher.json'

var dialog = ref(false)
var model = ref()
var instructionsDialog = ref(false)
var selectedLauncher = ref(null)
var currentStep = ref(1)
var Launchers = ref(LaunchersData)

const props = defineProps({
  home: {
    type: Boolean,
    default: false
  },
  isLoggedIn: {
    type: Boolean,
    default: false
  }
})
const {home} = toRefs(props)

function showInstructions(launcher) {
  selectedLauncher.value = launcher
  currentStep.value = 1
  instructionsDialog.value = true
}

function downloadLauncher(launcher) {
  window.open(launcher.url, '_blank')
}

</script>

<template>

<v-btn size="large" class="play" @click="dialog = true" v-if="home">PLAY NOW !</v-btn>
<div id="menu" @click="dialog = true" v-else>
  <v-icon icon="mdi-download"></v-icon>
<v-tooltip activator="parent" location="right">Download</v-tooltip>
    </div>

  <v-dialog transition="dialog-bottom-transition" :width="500" v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark color="primary" class="download-toolbar">
        <v-icon class="mr-2">mdi-download</v-icon>
        <div class="toolbar-content">
          <v-toolbar-title class="toolbar-main-title">Download</v-toolbar-title>
          <div class="toolbar-subtitle">Get started with NFS World</div>
        </div>
        <v-spacer></v-spacer>

        <template v-slot:extension>
          <v-tabs v-model="model" centered>
            <v-tab value="1">
              <v-icon class="mr-2" size="small">mdi-gavel</v-icon>
              Rules
            </v-tab>
            <v-tab value="2">
              <v-icon class="mr-2" size="small">mdi-clipboard-list</v-icon>
              Requirements
            </v-tab>
            <v-tab value="3">
              <v-icon class="mr-2" size="small">mdi-rocket-launch</v-icon>
              Download
            </v-tab>
          </v-tabs>
        </template>

      </v-toolbar>

      <v-window v-model="model">
        <v-window-item value="1">
          <v-card>
            <v-card-text>
              <Rules />
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item value="2">
          <v-card>
            <v-card-text class="pa-6">
              <div class="requirements-section">
                <div class="section-header mb-6">
                  <v-icon size="28" color="primary" class="mr-3">mdi-clipboard-list</v-icon>
                  <div>
                    <h3 class="section-title">System Requirements</h3>
                    <p class="section-subtitle">Minimum specifications to run the game</p>
                  </div>
                </div>

                <div class="requirements-grid">
                  <div class="requirement-card">
                    <div class="requirement-icon">
                      <v-icon size="40" color="primary">mdi-cpu-64-bit</v-icon>
                    </div>
                    <div class="requirement-info">
                      <div class="requirement-label">Processor</div>
                      <div class="requirement-value">Intel Pentium 4 2.0GHz</div>
                      <div class="requirement-sub">or AMD Athlon XP 2000+</div>
                    </div>
                  </div>

                  <div class="requirement-card">
                    <div class="requirement-icon">
                      <v-icon size="40" color="primary">mdi-expansion-card</v-icon>
                    </div>
                    <div class="requirement-info">
                      <div class="requirement-label">Graphics Card</div>
                      <div class="requirement-value">DirectX 9 Compatible</div>
                      <div class="requirement-sub">Graphics Card</div>
                    </div>
                  </div>

                  <div class="requirement-card">
                    <div class="requirement-icon">
                      <v-icon size="40" color="primary">mdi-memory</v-icon>
                    </div>
                    <div class="requirement-info">
                      <div class="requirement-label">Memory</div>
                      <div class="requirement-value">1.5 GB RAM</div>
                      <div class="requirement-sub">Minimum required</div>
                    </div>
                  </div>

                  <div class="requirement-card">
                    <div class="requirement-icon">
                      <v-icon size="40" color="primary">mdi-harddisk</v-icon>
                    </div>
                    <div class="requirement-info">
                      <div class="requirement-label">Storage</div>
                      <div class="requirement-value">6 GB</div>
                      <div class="requirement-sub">HDD or SSD</div>
                    </div>
                  </div>
                </div>

                <v-alert
                  type="info"
                  variant="tonal"
                  class="mt-6"
                  icon="mdi-information"
                >
                  <strong>Tip:</strong> These are the minimum requirements. For the best experience, we recommend using a more powerful system.
                </v-alert>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item value="3">
          <v-card>
            <v-card-text class="pa-6">
              <v-alert 
                type="info" 
                variant="tonal" 
                class="mb-6"
                icon="mdi-information"
              >
                <strong>Important:</strong> By downloading the launcher, you accept the server rules.
              </v-alert>

              <div class="launchers-section">
                <div class="section-header mb-4">
                  <v-icon size="28" color="primary" class="mr-3">mdi-rocket-launch</v-icon>
                  <div>
                    <h3 class="section-title">Available Launchers</h3>
                    <p class="section-subtitle">Choose your preferred launcher to get started</p>
                  </div>
                </div>

                <div class="launchers-grid">
                  <div 
                    v-for="Launcher in Launchers" 
                    :key="Launcher.name"
                    v-show="Launcher?.active"
                    class="launcher-modern-card"
                  >
                    <div class="launcher-header">
                      <div class="launcher-icon">
                        <v-icon size="32" color="primary">mdi-rocket-launch</v-icon>
                      </div>
                      <div class="launcher-info">
                        <h4 class="launcher-name">{{ Launcher.name }}</h4>
                        <p class="launcher-desc">{{ Launcher.description }}</p>
                      </div>
                    </div>

                    <div class="launcher-footer">
                      <v-btn 
                        variant="elevated" 
                        color="primary"
                        size="large"
                        @click="downloadLauncher(Launcher)" 
                        block
                        class="mb-2"
                      >
                        <v-icon class="mr-2">mdi-download</v-icon>
                        Download
                      </v-btn>
                      <v-btn 
                        variant="outlined" 
                        color="primary"
                        @click="showInstructions(Launcher)" 
                        block
                        size="small"
                      >
                        <v-icon class="mr-2">mdi-help-circle-outline</v-icon>
                        Installation Guide
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <v-divider class="my-6"></v-divider>

              <div class="additional-options-grid">
                <div class="option-card linux-card">
                  <div class="option-icon">
                    <v-icon size="40" color="success">mdi-linux</v-icon>
                  </div>
                  <div class="option-content">
                    <h4 class="option-title">Running on Linux?</h4>
                    <p class="option-desc">Get the Lutris version for seamless Linux gaming</p>
                  </div>
                  <v-btn 
                    variant="outlined" 
                    color="success"
                    href="https://lutris.net/games/soapbox-race-world-need-for-speed-world/"
                    target="_blank"
                    class="mt-3"
                    block
                  >
                    <v-icon class="mr-2">mdi-open-in-new</v-icon>
                    Get Lutris Version
                  </v-btn>
                </div>

                <div 
                  v-if="isLoggedIn"
                  class="option-card premium-card"
                >
                  <div class="option-icon">
                    <v-icon size="40" color="warning">mdi-crown</v-icon>
                  </div>
                  <div class="option-content">
                    <h4 class="option-title">Unlock Premium</h4>
                    <p class="option-desc">Get exclusive benefits and enhanced gameplay</p>
                  </div>
                  <v-btn
                    variant="elevated"
                    color="warning"
                    to="/premium"
                    class="mt-3"
                    block
                  >
                    <v-icon class="mr-2">mdi-star</v-icon>
                    Go Premium
                  </v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>

    </v-card>
  </v-dialog>

  <!-- Instructions Dialog -->
  <v-dialog v-model="instructionsDialog" max-width="650" scrollable>
    <v-card v-if="selectedLauncher" class="instructions-dialog" theme="dark">
      <v-toolbar dark color="primary" class="instructions-toolbar">
        <v-icon class="mr-3">mdi-book-open-page-variant</v-icon>
        <v-toolbar-title class="text-h6">{{ selectedLauncher.name }} - Installation Guide</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon variant="text" @click="instructionsDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6 instruction-content">
        <v-alert 
          type="info" 
          variant="outlined" 
          class="mb-6 instruction-alert"
        >
          <v-icon slot="prepend">mdi-information</v-icon>
          Follow these steps to install and set up {{ selectedLauncher.name }}
        </v-alert>

        <div class="instructions-list">
          <div 
            v-for="(instruction, index) in selectedLauncher.instructions" 
            :key="index"
            class="instruction-step mb-4"
            :class="{ 'active-step': currentStep === index + 1 }"
          >
            <div class="step-header d-flex align-center mb-3">
              <v-avatar 
                :color="currentStep >= index + 1 ? 'primary' : 'grey'" 
                size="32" 
                class="mr-3"
              >
                <v-icon v-if="currentStep > index + 1" color="white">mdi-check</v-icon>
                <span v-else class="text-white font-weight-bold">{{ index + 1 }}</span>
              </v-avatar>
              <h4 class="step-title">Step {{ index + 1 }}</h4>
            </div>
            
            <div class="step-content">
              <p class="instruction-text">{{ instruction }}</p>
            </div>
          </div>
        </div>

        <div class="navigation-controls mt-6 d-flex justify-space-between">
          <v-btn 
            v-if="currentStep > 1"
            variant="outlined"
            @click="currentStep = currentStep - 1"
            prepend-icon="mdi-arrow-left"
            class="nav-btn"
          >
            Previous
          </v-btn>
          <v-spacer v-if="currentStep === 1"></v-spacer>
          
          <v-btn 
            v-if="currentStep < selectedLauncher.instructions.length"
            variant="elevated"
            color="primary"
            @click="currentStep = currentStep + 1"
            append-icon="mdi-arrow-right"
            class="nav-btn"
          >
            Next
          </v-btn>
          
          <v-btn 
            v-else
            variant="elevated"
            color="success"
            @click="downloadLauncher(selectedLauncher)"
            prepend-icon="mdi-download"
            class="nav-btn"
          >
            Download Now
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions class="pa-6 pt-0">
        <v-btn 
          variant="outlined" 
          @click="instructionsDialog = false"
          prepend-icon="mdi-close"
        >
          Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          variant="elevated" 
          color="success" 
          @click="downloadLauncher(selectedLauncher)"
          prepend-icon="mdi-download"
          size="large"
        >
          Download {{ selectedLauncher.name }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style>
.v-list-item__prepend {
  font-size: 30px!important;
  margin-top: 10px;
}
</style>
<style scoped>
.launchers-section {
  margin-bottom: 24px;
}

.launchers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.launcher-modern-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}

.launcher-modern-card:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgb(var(--v-theme-primary));
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.launcher-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 16px;
}

.launcher-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(var(--v-theme-primary), 0.15);
  border-radius: 10px;
}

.launcher-info {
  flex: 1;
}

.launcher-name {
  font-size: 1.15rem;
  font-weight: 600;
  margin: 0 0 6px 0;
  color: white;
}

.launcher-desc {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.4;
}

.launcher-footer {
  display: flex;
  flex-direction: column;
}

.additional-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.option-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  transition: all 0.3s ease;
}

.option-card:hover {
  background: rgba(255, 255, 255, 0.05);
  transform: translateY(-2px);
}

.linux-card:hover {
  border-color: rgb(var(--v-theme-success));
}

.premium-card {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%);
  border-color: rgba(255, 193, 7, 0.3);
}

.premium-card:hover {
  border-color: rgb(var(--v-theme-warning));
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.15) 0%, rgba(255, 152, 0, 0.15) 100%);
}

.option-icon {
  margin-bottom: 16px;
}

.option-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: white;
}

.option-desc {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.4;
}

.instructions-dialog .instruction-card {
  background: rgba(66, 66, 66, 0.8) !important;
  border-left: 4px solid rgb(25, 118, 210);
}

.instructions-dialog {
  background: #1e1e1e !important;
}

/* New instruction guide styles */
.instruction-content {
  color: white !important;
}

.instruction-alert {
  background: rgba(33, 150, 243, 0.1) !important;
  border-color: rgba(33, 150, 243, 0.5) !important;
  color: white !important;
}

.instructions-list {
  max-height: 400px;
  overflow-y: auto;
}

.instruction-step {
  padding: 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.instruction-step.active-step {
  background: rgba(25, 118, 210, 0.15);
  border-color: rgb(25, 118, 210);
}

.step-header {
  margin-bottom: 8px;
}

.step-title {
  color: white !important;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.step-content {
  margin-left: 48px;
}

.instruction-text {
  color: rgba(255, 255, 255, 0.9) !important;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
}

.navigation-controls {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 16px;
  margin-top: 24px;
}

.nav-btn {
  min-width: 120px;
}

.instruction-text {
  white-space: normal !important;
  word-wrap: break-word;
  line-height: 1.6;
  font-size: 1rem;
}

.step-navigation {
  margin-top: 24px;
}

.instructions-toolbar {
  border-radius: 4px 4px 0 0;
}

/* Requirements Section Styles */
.requirements-section {
  padding: 0;
}

.section-header {
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 2px solid rgba(var(--v-theme-primary), 0.3);
}

.section-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
}

.section-subtitle {
  margin: 4px 0 0 0;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.4;
}

.requirements-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-top: 24px;
}

.requirement-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;
}

.requirement-card:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(var(--v-theme-primary), 0.3);
  transform: translateY(-2px);
}

.requirement-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(var(--v-theme-primary), 0.1);
  border-radius: 10px;
}

.requirement-info {
  flex: 1;
}

.requirement-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.requirement-value {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2px;
}

.requirement-sub {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .requirements-grid {
    grid-template-columns: 1fr;
  }

  .launchers-grid {
    grid-template-columns: 1fr;
  }

  .additional-options-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .step-navigation {
    flex-direction: column;
    gap: 12px;
  }
}

/* Toolbar Styles */
.download-toolbar {
  padding: 8px 16px !important;
}

.toolbar-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.toolbar-main-title {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
}

.toolbar-subtitle {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1;
}

button {
  margin: initial !important;
}

#menu {
    font-weight: bold;
    color: white;
    text-decoration: none;
    border-radius: 6px;
    margin-bottom: 10px;
    height: 40px;
    width: 40px;
    background: transparent;
    transition: all 0.15s ease-in-out;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    cursor: pointer;
}

#menu i {
    margin: 0 7px;
}

.play {
    margin-bottom: 20px!important;
    background: var(--tertiary-color);
    margin-top: 30px;
}

.router-link-active {
    font-weight: bold;
    border-left: 2px solid white;
    background: var(--tertiary-color) !important;
    color: white;
    vertical-align: middle;
}

#menu:hover {
    font-weight: bold;
    background: var(--quaternary-color);
    color: white;
    vertical-align: middle;
}
</style>

<style>
.v-list-item-title {
  margin: 10px 0 !important;
}
</style>